import Button from '@/components/Button';
import Input from '@/components/Input';
import { FiCheck, FiX } from '@/components/react-icons/main';
import * as Popover from '@radix-ui/react-popover';
import { useState } from 'react';

const PopoverInput = ({ children, initialValue = '', width = 200, minWidth = 200, side = 'bottom', align = 'center', sideOffset = 4, onSave, onOpenChange, className = '', title = '', disabled = false }) => {
  const [value, setValue] = useState('');
  const [open, setOpen] = useState(false);

  const handleChange = (e) => {
    setValue(e.target.value);
  };

  const handleOpenChange = (isOpen) => {
    if (disabled) {
      return;
    }

    if (isOpen) {
      setValue(initialValue);
    } else {
      setValue('');
    }
    setOpen(isOpen);
    onOpenChange?.(isOpen);
  };

  const handleSave = () => {
    onSave?.(value);
    setOpen(false);
  };

  const handleCancel = () => {
    setValue('');
    setOpen(false);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSave();
    }
  };

  return (
    <Popover.Root open={open} onOpenChange={handleOpenChange}>
      <Popover.Trigger asChild disabled={disabled}>
        <div className={`${className}${disabled ? ' disabled' : ''}`} data-title={title}>
          {children}
        </div>
      </Popover.Trigger>
      <Popover.Portal>
        <Popover.Content className="popover-content" side={side} align={align} sideOffset={sideOffset}>
          <div className="popover-input-wrapper">
            <Input value={value} onChange={handleChange} onKeyDown={handleKeyDown} autoFocus size="sm" style={{ width, minWidth }} />
            <div className="popover-actions">
              <Button className="ghost" icon={FiX} onClick={handleCancel} size="sm" />
              <Button className="ghost" icon={FiCheck} onClick={handleSave} size="sm" />
            </div>
          </div>
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
};

export default PopoverInput;
